export default {
	data() {
		return {
			fetchError: null
		};
	},

	mounted() {
		window.addEventListener("onSessionLoad", this.onSessionLoad, false);
	},
	beforeDestroy() {
		window.removeEventListener("onSessionLoad", this.onSessionLoad);
	},

	computed: {
		fetchErrorMessage() {
			return this.$te(this.fetchError) ? this.$t(this.fetchError) : this.fetchError;
		}
	},

	methods: {
		// Return translation if it exists
		t(key) {
			return this.$te(key) ? this.$t(key) : key;
		},

		// Fetch json from server api
		fetch(url, callback) {
			fetch(url)
				.then(response => response.text())
				.then(message => {
					let data = null;
					try {
						data = JSON.parse(message);
						this.fetchError = data.error || null;
					}
					catch (error) {
						this.fetchError = message;
						callback(null);
					}
					if (data) {
						try {
							callback(data);
						}
						catch (error) {
							this.fetchError = error;
							callback(null);
						}
					}
				})
				.catch(error => {
					this.fetchError = error.toString();
					callback(null);
				})
		},

		// Reset error status from fetch
		clearFetchError() {
			this.fetchError = null;
		},


		// Convert route name to id
		routeToId(moduleRoute, taskRoute) {
			let text = taskRoute ? `${moduleRoute}_${taskRoute}` : moduleRoute;
			// text = text.replace("module-", "m");
			text = text.replace("forest", "m2");
			text = text.replace("global", "m1");
			text = text.replace("intervention", "m3");
			text = text.replace("task-", "t");
			text = text.replace("quiz-", "c");
			return text;
		},

		// Convert route name to number
		routeToNumber(route) {
			return route.split('-').pop();
		},

		// Fetch translation via id and key
		getText(id, key) {
			if (key) {
				return this.$t(`${id}_${key}`);
			}
			return this.$t(`${id}`);
		},

		// Return shuffled array
		shuffle(array) {
			let m = array.length, t, i;
			while (m) {
				i = Math.floor(Math.random() * m--);
				t = array[m];
				array[m] = array[i];
				array[i] = t;
			}
			return array;
		},

		// Return distance between two x,y points
		distanceBetween(a, b) {
			const dx = a.x - b.x;
			const dy = a.y - b.y;
			return Math.sqrt(dx*dx + dy*dy);
		},

		onSessionLoad() {},
	},
};
